import type { A11yWizardEditorAdapter } from '@wix/a11y-adapters/editor';

import type { Shell, SlotKey } from '#packages/apilib';
import type { FunctionComponent } from 'react';

export interface A11yWizardAdapterAPI extends A11yWizardEditorAdapter {
  contributePanel: (shell: Shell, component: FunctionComponent<{}>) => void;
  getPanelState?: () => Record<string, any> | undefined;
}

export const A11yAdapterApiKey: SlotKey<A11yWizardAdapterAPI> = {
  name: 'A11yWizardAdapterAPI',
  layer: 'UI',
  public: true,
};
